import { TypedDispatch, TypedThunk } from "App/Store";
import { BRACKET_TEAM_ACTION } from "core/constants/Actions";
import {  getBracketTeams } from "core/services/Bracket";

export function getBracketTeamsDetails(tournamentId: string | number): TypedThunk {
  return async (dispatch: TypedDispatch): Promise<void> => {
    dispatch({ type: BRACKET_TEAM_ACTION.REQUEST });
    const apiResponse = await getBracketTeams(tournamentId);
    if (apiResponse.status && apiResponse.data) {
      dispatch({
        type: BRACKET_TEAM_ACTION.SUCCESS,
        payload: { bracketTeams: apiResponse.data.bracketTeams },
      });
    } else {
      dispatch({
        type: BRACKET_TEAM_ACTION.FAILURE,
      });
    }
  };
}
